module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tags-pane"
  }, [_c('div', {
    staticClass: "tags-title"
  }, [_vm._v("tags")]), _c('div', {
    staticClass: "tags"
  }, _vm._l((_vm.tags), function(tag, key) {
    return _c('h5', {
      key: key,
      class: [{
        'first': key === 0
      }]
    }, [(tag.tid) ? _c('term-link', {
      attrs: {
        "tid": tag.tid,
        "title": tag.title,
        "url": tag.relative_url,
        "type": tag.type
      }
    }, [_vm._v(_vm._s(tag.title))]) : _vm._e()], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a904b68c","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/node/Tag.vue
// module id = 1778
// module chunks = 1